module.exports = __webpack_public_path__ + "static/media/prince_start.c143dbc5.gif";